<template>
  <div>
    <form name="warrantyPeriodForm" action method class="mt-10">
      <p class="mt-8 mb-0 title font-weight-light font-weight-bold">
        정품 인증 기간 설정
      </p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
        아래 설정에 따라 정품 시리얼 코드 생성시에 보증기간이 기본적으로
        설정됩니다.
      </p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
        개별 상품에 대한 기간 변경은 [정품 인증 생성] [정품인증코드 관리]
        메뉴에서 별도 설정이 가능하오니 참고해주세요.
      </p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium primary--text">
        ※ 고객 정품 구매일 기준으로 설정시 '회원 정품 인증 추가 항목' 탭
        메뉴에서 구매일자 입력이 필수로 설정됩니다.
      </p>

      <v-radio-group v-model="payload.cert_duration_type" class="mt-5 ml-0">
        <div class="raudio">
          <v-radio
            :id="AUTH_SERVICE.ACTIVATED"
            :value="AUTH_SERVICE.ACTIVATED"
            name="warrantyType"
            style="display: inline;"
          ></v-radio>
          <label :for="AUTH_SERVICE.ACTIVATED" class="textVerticalAlign"
            >고객 정품 인증일 기준</label
          >
          <v-col sm="2" md="2" class="d-inline-block col-auto mr-auto textSize">
            <v-text-field
              :disabled="payload.cert_duration_type !== AUTH_SERVICE.ACTIVATED"
              v-model="duration.activated.count"
              type="number"
              min="1"
              max="999"
              class="durationCountText"
              outlined
              solo
              @keydown="M.checkNumber($event)"
              @keyup="M.replaceDateCount($event, duration.activated.type)"
              @blur="M.replaceDateCount($event, duration.activated.type)"
              hide-details
            ></v-text-field>
          </v-col>

          <v-col class="d-inline-block selectSize" cols="2" sm="2">
            <v-select
              :items="items"
              solo
              outlined
              class="d-inline-block col-auto mr-auto"
              v-model="duration.activated.type"
              @change="initCount(duration.activated)"
              :disabled="payload.cert_duration_type !== AUTH_SERVICE.ACTIVATED"
              hide-details
            ></v-select>
          </v-col>
          <label :for="AUTH_SERVICE.ACTIVATED" class="textVerticalAlign"
            >까지 정품 보증을 지원합니다.</label
          >
        </div>

        <div class="raudio audioBottom">
          <v-radio
            :id="AUTH_SERVICE.CREATED"
            :value="AUTH_SERVICE.CREATED"
            name="warrantyType"
            style="display: inline;"
          ></v-radio>
          <label :for="AUTH_SERVICE.CREATED" class="textVerticalAlign"
            >정품 인증 코드 생성일 기준</label
          >
          <v-col sm="2" md="2" class="d-inline-block col-auto mr-auto textSize">
            <v-text-field
              :disabled="payload.cert_duration_type !== AUTH_SERVICE.CREATED"
              v-model="duration.created.count"
              type="number"
              min="1"
              max="999"
              class="durationCountText"
              outlined
              solo
              @keydown="M.checkNumber($event)"
              @keyup="M.replaceDateCount($event, duration.created.type)"
              @blur="M.replaceDateCount($event, duration.created.type)"
              hide-details
            ></v-text-field>
          </v-col>

          <v-col
            class="d-inline-block col-auto mr-auto selectSize"
            cols="2"
            sm="2"
          >
            <v-select
              :items="items"
              solo
              outlined
              class="d-inline-block"
              v-model="duration.created.type"
              @change="initCount(duration.created)"
              :disabled="payload.cert_duration_type !== AUTH_SERVICE.CREATED"
              hide-details
            ></v-select>
          </v-col>
          <label :for="AUTH_SERVICE.CREATED" class="textVerticalAlign"
            >까지 정품 보증을 지원합니다.</label
          >
        </div>

        <div class="raudio audioBottom">
          <v-radio
            :id="AUTH_SERVICE.BOUGHT"
            :value="AUTH_SERVICE.BOUGHT"
            name="warrantyType"
            style="display: inline;"
          ></v-radio>
          <label :for="AUTH_SERVICE.BOUGHT" class="textVerticalAlign"
            >고객 정품 구매일 기준</label
          >
          <v-col sm="2" md="2" class="d-inline-block col-auto mr-auto textSize">
            <v-text-field
              :disabled="payload.cert_duration_type !== AUTH_SERVICE.BOUGHT"
              v-model="duration.bought.count"
              type="number"
              min="1"
              max="999"
              class="durationCountText"
              outlined
              solo
              @keydown="M.checkNumber($event)"
              @keyup="M.replaceDateCount($event, duration.bought.type)"
              @blur="M.replaceDateCount($event, duration.bought.type)"
              hide-details
            ></v-text-field>
          </v-col>

          <v-col
            class="d-inline-block col-auto mr-auto selectSize"
            cols="2"
            sm="2"
          >
            <v-select
              :items="items"
              solo
              outlined
              class="d-inline-block"
              v-model="duration.bought.type"
              @change="initCount(duration.bought)"
              :disabled="payload.cert_duration_type !== AUTH_SERVICE.BOUGHT"
              hide-details
            ></v-select>
          </v-col>
          <label :for="AUTH_SERVICE.BOUGHT" class="textVerticalAlign"
            >까지 정품 보증을 지원합니다.</label
          >
        </div>
      </v-radio-group>

      <p class="mt-8 mb-0 title font-weight-light font-weight-bold">
        정품 인증 관리자 승인 설정
      </p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
        고객이 정품 인증 후 관리자 승인 처리 여부를 설정할 수 있습니다.
      </p>

      <v-radio-group v-model="approval" class="mt-2 ml-0">
        <div class="mt-3">
          <v-radio style="display: inline;" value="disabled"></v-radio>
          <label class="textVerticalAlign mr-10">사용안함</label>
          <v-radio style="display: inline;" value="enabled"></v-radio>
          <label class="textVerticalAlign">사용함</label>
        </div>
      </v-radio-group>

      <div class="mt-8">
        <div class="d-flex">
          <p class="mb-0 title font-weight-light font-weight-bold mr-5">
            정품 인증 노출 문구 변경
          </p>
          <!-- <v-btn small>예시 참고</v-btn> -->
        </div>

        <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
          쇼핑몰 운영 정책 및 제품 성격에 따라 노출되는 문구를 변경할 수
          있습니다.
        </p>
        <div class="mt-6 mb-2 d-flex align-center">
          <v-select
            v-model="display.text"
            :items="displayt_text_items"
            solo
            outlined
            class="mr-5"
            hide-details
            style="max-width:200px;"
            max-width="200"
          ></v-select>
          <p class="mb-0">으로 쇼핑몰 노출 문구를 설정합니다.</p>
        </div>
      </div>

      <div class="mt-15">
        <div class="d-flex">
          <p class="mb-0 title font-weight-light font-weight-bold mr-5">
            분실 버튼 노출 설정
          </p>
          <!-- <v-btn small>예시 참고</v-btn> -->
        </div>

        <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
          인증 후 보여지는 '정품 인증 내역' 화면에 분실 버튼 노출 여부를
          설정합니다.<br />
          분실 기능을 사용하는 경우 '사용함'으로 설정합니다.
        </p>
        <div class="mt-2 d-flex align-center">
          <v-radio-group v-model="display.lost" class="ml-0">
            <div>
              <v-radio style="display: inline;" value="disabled"></v-radio>
              <label class="textVerticalAlign mr-10">사용안함</label>
              <v-radio style="display: inline;" value="enabled"></v-radio>
              <label class="textVerticalAlign">사용함</label>
            </div>
          </v-radio-group>
        </div>
      </div>
      <div class="mt-10">
        <div class="d-flex">
          <p class="mb-0 title font-weight-light font-weight-bold mr-5">
            인증 취소 버튼 노출 설정
          </p>
          <!-- <v-btn small>예시 참고</v-btn> -->
        </div>

        <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
          인증 후 보여지는 '정품 인증 내역' 화면에 인증 취소 버튼 노출 여부를
          설정합니다.<br />
          고객이 쇼핑몰에서 인증 취소를 할 수 있도록 사용하는 경우 '사용함'으로
          설정합니다.
        </p>
        <div class="mt-2 d-flex align-center">
          <v-radio-group v-model="display.cancel" class="ml-0">
            <div>
              <v-radio style="display: inline;" value="disabled"></v-radio>
              <label class="textVerticalAlign mr-10">사용안함</label>
              <v-radio style="display: inline;" value="enabled"></v-radio>
              <label class="textVerticalAlign">사용함</label>
            </div>
          </v-radio-group>
        </div>
      </div>
      <div class="mt-10">
        <div class="d-flex">
          <p class="mb-0 title font-weight-light font-weight-bold mr-5">
            보증기간 노출 설정
          </p>
          <!-- <v-btn small>예시 참고</v-btn> -->
        </div>

        <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
          인증 후 보여지는 '정품 인증 내역' 화면에 보증기간 노출 여부를
          설정합니다.
        </p>
        <div class="mt-2 d-flex align-center">
          <v-radio-group v-model="display.warranty" class="ml-0">
            <div>
              <v-radio style="display: inline;" value="disabled"></v-radio>
              <label class="textVerticalAlign mr-10">사용안함</label>
              <v-radio style="display: inline;" value="enabled"></v-radio>
              <label class="textVerticalAlign">사용함</label>
            </div>
          </v-radio-group>
        </div>
      </div>
    </form>

    <div class="row justify-center mt-0">
      <v-btn large color="primary" @click.prevent="saveDuration" class="saveBtn"
        >저장</v-btn
      >
    </div>
  </div>
</template>

<style scoped>
.saveBtn {
  color: unset;
  text-decoration: none;
  width: 200px;
}
.audio {
  height: 50px;
}

.audioBottom {
  margin-bottom: 0px;
}

.textSize {
  width: 100px;
  padding-right: 0px;
  vertical-align: super;
}

.selectSize {
  width: 115px;
  vertical-align: super;
}

.durationCountText >>> input {
  text-align: left;
}

.textVerticalAlign {
  vertical-align: text-bottom;
}

.mt-15 {
  margin-top: 60px !important;
}
</style>

<script>
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data: () => ({
    M,
    AUTH_SERVICE,
    items: [
      {
        text: "일",
        value: "d",
      },
      {
        text: "개월",
        value: "m",
      },
      {
        text: "년",
        value: "y",
      },
    ],
    duration: {
      activated: {
        count: "",
        type: "d",
      },
      created: {
        count: "",
        type: "d",
      },
      bought: {
        count: "",
        type: "d",
      },
    },
    payload: {
      cert_duration_type: "",
      cert_duration: "",
    },
    approval: "disable",
    displayt_text_items: [
      { text: "정품 인증", value: "정품 인증" },
      { text: "구매 인증", value: "구매 인증" },
      { text: "기기 인증", value: "기기 인증" },
      { text: "정품 등록", value: "정품 등록" },
      { text: "제품 등록", value: "제품 등록" },
      { text: "기기 등록", value: "기기 등록" },
    ],
    display: {
      text: "정품 인증",
      lost: "disabled",
      warranty: "enabled",
      cancel: "enabled",
    },
  }),
  created: async function() {
    /**
     * 데이터 가져오기
     */
    await this.getDuration();
    /**
     * 정품 인증 관리자 승인 설정
     */
    await this.getApproval();

    /**
     * 노출-설정-조회
     */
    await this.getConfigDisplay();
  },
  mixins: [CommonMixin],
  methods: {
    /**
     * 데이터 가져오기
     */
    getDuration: async function() {
      let data = await M.api(M.entry("/get/duration"), {});

      if (data) {
        this.payload.cert_duration_type = data.duration_type;
        this.payload.cert_duration = data.duration;
      }
      this.setDisplayDuration();
    },
    /**
     * 셋팅
     */
    setDisplayDuration: function() {
      if (this.payload.cert_duration !== "") {
        let count = this.payload.cert_duration.replace(/[a-z]/gi, "");
        let type = this.payload.cert_duration.replace(/[0-9]/g, "");
        AUTH_SERVICE.CERT_DURATION_TYPE_LIST.forEach((typeName) => {
          if (this.payload.cert_duration_type === typeName) {
            this.duration[typeName].count = count;
            this.duration[typeName].type = type;
          } else {
            this.duration[typeName].count = "";
            this.duration[typeName].type = "d";
          }
        });
      }
    },
    /**
     * 폼체크
     */
    checkPayload: function() {
      let type = this.payload.cert_duration_type;
      if (this.duration[type].count === "") {
        this.alertShow("기준일을 입력하세요.");
        return false;
      }
      return true;
    },
    /**
     * 저장
     */
    saveDuration: async function() {
      if (!this.checkPayload()) {
        return false;
      }
      let type = this.payload.cert_duration_type;
      this.payload.cert_duration = `${this.duration[type].count}${this.duration[type].type}`;
      await M.api(M.entry("/put/duration"), this.payload);

      await this.putApproval();

      await this.setAuthItems();

      await this.putConfigDisplay();

      this.alertShow("저장되었습니다.");
      this.eventHub.$emit("setList", "reSearch");
    },
    /**
     * 셀렉트박스 변경시 카운트 초기화
     */
    initCount: function(type) {
      type.count = "";
    },
    /**
     * 정품 인증 관리자 승인 설정
     */
    getApproval: async function() {
      try {
        let data = await M.api(M.entry("/get/config/approval"), {});
        if (data) {
          this.approval = data.status;
        }
      } catch (e) {
        //console.log(e);
      }
    },
    putApproval: async function() {
      await M.api(M.entry("/put/config/approval"), {
        status: this.approval,
      });
    },

    getAuthItems: async function() {
      let data = await M.api(M.entry("/get/config/authItems"), {});
      return data;
    },
    /**
     * 고객 정품 구매일 기준으로 저장 시 항목 저장 ( 구매일자 등록 필요 )
     */
    setAuthItems: async function() {
      if (this.payload.cert_duration_type == "bought") {
        let data = await this.getAuthItems();
        if (data.length < 1 || !data) {
          let setItems = [
            {
              id: 0,
              text: "구매일자",
              type: "date",
              require: true,
            },
          ];
          await M.api(M.entry("/post/config/authItems"), setItems);
        }
      }
    },

    getConfigDisplay: async function() {
      try {
        const display_result = await M.api(M.entry("/get/config/display"));
        if (display_result.text) {
          this.display.text = display_result.text;
        }
        if (display_result.lost) {
          this.display.lost = display_result.lost;
        }
        if (display_result.warranty) {
          this.display.warranty = display_result.warranty;
        }
        if (display_result.cancel) {
          this.display.cancel = display_result.cancel;
        }
      } catch (e) {
        console.log(e);
      }
    },
    putConfigDisplay: async function() {
      await M.api(M.entry("/put/config/display"), this.display);
    },
  },
};
</script>
